import { FormikErrors } from 'formik'

export const getFieldErrorNames = (formikErrors: FormikErrors<any>) => {
  const transformObjectToDotNotation = (obj: any, prefix = '', result = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key]
      if (!value) return

      const nextKey = prefix ? `${prefix}.${key}` : key
      if (typeof value === 'object') {
        transformObjectToDotNotation(value, nextKey, result)
      } else {
        // @ts-ignore
        result.push(nextKey)
      }
    })

    return result
  }

  return transformObjectToDotNotation(formikErrors)
}

export const convertToDayPassed = (date: string): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1)

  return new Date(new Date(newDate).setMinutes(new Date(newDate).getMinutes() - 1))
}
